import { RouteObject } from 'react-router';

import guestRouter from './Guest';
import commonRouter from './Common';
import privateRouter from './Private';

const router: RouteObject[] = [
  {
    ...commonRouter,
  },
  {
    ...guestRouter,
  },
  {
    ...privateRouter,
  },
];

export default router;
